export default {
	routes: {
		home: {
			path: '/',
			name: 'home',
			isFooter: true,
		},

		aboutUs: {
			path: '/about-us/',
			name: 'aboutUs',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		products: {
			path: '/products/',
			name: 'products',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		benefits: {
			path: '/benefits/',
			name: 'benefits',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		recipes: {
			path: '/recipes/',
			name: 'recipes',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		blog: {
			path: '/blog/',
			name: 'blog',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		contactUs: {
			path: '/contact-us/',
			name: 'contactUs',
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		privacyPolicy: {
			path: '/privacy-policy/',
			name: 'privacyPolicy',
			isDefaultHeaderBackground: true,
		},

		faq: {
			path: '/faq/',
			name: 'faq',
			isHeader: true,
			isFooter: true,
			isDefaultHeaderBackground: true,
		},

		termsOfUse: {
			path: '/terms-of-use/',
			name: 'termsOfUse',
			isDefaultHeaderBackground: true,
		},

		notFound: {
			path: '/not-found/',
			name: 'notFound',
			isDefaultHeaderBackground: true,
		},
	},
};
